import React, { useState } from "react";
import {
  Image,
  Button,
  Icon,

  Modal,
  Table,
  TableCell,
  Popup,
} from "semantic-ui-react";
import { image } from "../../../../assets";
import { Site } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmModal } from "../../../Shared";
import { ENV } from "../../../../utils";
import { SiteForm } from "../SiteForm";
import "./SiteItem.scss";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";

const siteController = new Site();

export function SiteItem(props) {
  const { site, onReload, permissionsByRole } = props;
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // Estado para abrir/cerrar el modal
  const [contentModal, setContentModal] = useState("");


  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const openUpdateSite = () => {
    setTitleModal(`${t("update")} ${site.name ? site.name : ""}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmMessage(
      site.active
        ? `${t("question_inactive")} "${site.name ? site.name : ""}"`
        : `${t("question_active")} "${site.name ? site.name : ""}"`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await siteController.updateSite(accessToken, site._id, {
        active: !site.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`${t("are_you_sure_you_want_to_remove")} "${site.name ? site.name : ""}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await siteController.deleteSite(accessToken, site._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      setContentModal(error.msg);
      setModalOpen(true);
      onOpenCloseConfirm();
    
    }
  };

   // Manejador de cierre del modal
   const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Table.Row key={site._id}>
        <Table.Cell>{site.name ? site.name : ""}</Table.Cell>
          <Table.Cell>{site.cuit}</Table.Cell>
            <Table.Cell>{site.phone}</Table.Cell>
        <Table.Cell>{site.email}</Table.Cell>
        <Table.Cell>
          { isMaster(role) || isAdmin(role) ||
          hasPermission(permissionsByRole, role._id, "sites", "edit") ? (
          <Popup
                         content={t("edit")}
                         trigger={
                           <Button icon primary onClick={openUpdateSite}>
                             <Icon name="pencil" />
                           </Button>
                         }
                       />
          ) : null}
          {isMaster(role) || isAdmin(role) ||
          hasPermission(permissionsByRole, role._id, "sites", "edit") ? (
            <Popup
                           content={site.active ? t("deactivate") : t("activate")}
                           trigger={
                             <Button
                               icon
                               color={site.active ? "orange" : "teal"}
                               onClick={openDesactivateActivateConfim}
                             >
                               <Icon name={site.active ? "ban" : "check"} />
                             </Button>
                           }
                         />
          ) : null}
          {/* Borrar sitios: solo master (el servidor lo exige). Para una
              planta que cierra, desactivarla. */}
          {isMaster(role) ? (
                 <Popup
    content={t("delete")}
    trigger={
      <Button icon color="red" onClick={openDeleteConfirm}>
        <Icon name="trash" />
      </Button>
    }
  />
          ) : null}
        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size={"small"}>
        <SiteForm close={onOpenCloseModal} onReload={onReload} site={site} />
      </BasicModal>

      <ConfirmModal
        open={showConfirm}
        title={isDelete ? t("delete") : t("activate_deactivate")}
        content={confirmMessage}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        onCancel={onOpenCloseConfirm}
        danger={isDelete}
      />

       {/* Modal de advertencia si no hay datos */}
       <Modal open={modalOpen} onClose={closeModal} size="tiny">
        <Modal.Header>
          <Icon name="warning sign" /> Advertencia
        </Modal.Header>
        <Modal.Content>
          <p>{contentModal}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
